export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  var camera;
  domc.addType('webrtc_widget', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'webrtc',
          tagName: 'div',
          src: '',
          width: '320',
          height: '400',
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1
            },
            {
              type: 'number',
              label: 'width',
              name: 'width',
              changeProp: 1
            },
            {
              type: 'number',
              label: 'height',
              name: 'height',
              changeProp: 1
            }
          ]
        }),
        init() {
          this.listenTo(this, 'change:src', this.updateSrc);
          this.listenTo(this, 'change:width ', this.updateWidth);
          this.listenTo(this, 'change:height ', this.updateHeight);
        },
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') === 'webrtc_widget'
            ? this.view.el.outerHTML
            : '';
        },
        updateSrc() {
          this.view.getIframe().src = this.createUri();
        },
        createUri() {
          // this.updateWidth();
          // this.updateHeight();
          return this.get('src');
        },
        updateWidth() {
          this.view.getIframe().width = this.get('width');
          this.view.getIframe().parentNode.style.width = this.get('width');
        },
        updateHeight() {
          this.view.getIframe().height = this.get('height');
          this.view.getIframe().parentNode.style.height = this.get('height');
        }
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: 'webrtc_widget' };
          }
          return result;
        }
      }
    ),
    view: defaultView.extend({
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      getScript(src) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.charset = 'utf-8';
        script.src = src;
        script.async = true;
        return script;
      },

      getIframe() {
        camera = document.createElement('div');
        camera.innerHTML = '<video   width="100%" height="100%" controls autoplay></video>';

        return camera.firstChild;
      },

      render(...args) {
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length == 0) {
          this.el.appendChild(this.getIframe());
        }
        return this;
      }
    })
  });
};



// WEBPACK FOOTER //
// ./src/plugins/webrtc/components.js